import React, { useContext, useState } from 'react';

import { Avatar } from '@mui/material';

import ProfileMenu from './sections/ProfileMenu/ProfileMenu';
import { ReactComponent as ChevronDownIcon } from '../../../../../assets/icons/v3/chevron-down.svg';
import { CLICK_ACTION, PROFILE_DROPDOWN } from '../../../../constants/tagManager';
import { SessionContext } from '../../../../context/auth/authContext';
import tagManagerService from '../../../../services/gtm/tagManagerService';
import { getInitialsLetters } from '../../../../utils/utils';
import GenericSideBar from '../GenericSideBar/GenericSideBar';

import './UserSelector.scss';

const UserSelector = () => {
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const { user } = useContext(SessionContext);

  const handleClosedUserMenu = () => {
    setOpenUserMenu(false);
  };

  const handleClick = () => {
    tagManagerService.pushEvent(CLICK_ACTION, PROFILE_DROPDOWN);
    setOpenUserMenu(!openUserMenu);
  };

  const username = user.name || user.email.split('@')[0];

  return (
    <>
      <button className="user-selector-v3" onClick={handleClick} data-experience="new">
        <Avatar
          className={`user-avatar ${user.image ? 'avatar-image' : 'avatar-initials'}`}
          alt={username}
          style={{ backgroundImage: `url("${user.image}")` }}
        >
          {!user.image && getInitialsLetters(username, ' ')}
        </Avatar>
        <div className="header-name">{username}</div>
        <ChevronDownIcon className="m-2" data-testid="chevron-down-icon" />
      </button>
      <GenericSideBar removePadding={true} isOpen={openUserMenu} onClose={handleClosedUserMenu} position="right">
        <ProfileMenu />
      </GenericSideBar>
    </>
  );
};

export default UserSelector;
